import { Document, Page, Text, View } from "@react-pdf/renderer";
import { format, addDays, getDaysInMonth, isWeekend } from 'date-fns';
import { enUS } from 'date-fns/locale';
import sharedStyles from "./PdfStyles";
import PdfUser from "./PdfUser";
import VariantWordmark from "./VariantWordmark";
import VariantLogoSymbol from "./VariantLogoSymbol";
import { currencyFormate, formate } from "./utiil/Formate";

const PdfInvoice = ({ project }) => {

    const firstDate = new Date(project.period.year, project.period.month, 1);
    const lastDay = getDaysInMonth(firstDate);
    const users = Object.values(project.users);

    const periodName = format(firstDate, 'MMMM yyyy', { locale: enUS })
        .replace(/./, c => c.toUpperCase());

    // Column header day numbers
    const dayHeaders = [];
    const sumCells = [];
    for (let d = 1; d <= lastDay; d++) {
        const weekend = isWeekend(addDays(firstDate, d - 1));
        dayHeaders.push(
            <View key={d} style={sharedStyles.heading_cell_days}>
                <Text style={{
                    ...sharedStyles.heading_text,
                    ...(weekend ? sharedStyles.weekend_text : {}),
                }}>
                    {d}
                </Text>
            </View>
        );

        const val = project.entries[d] ? formate(project.entries[d]) : '-';
        sumCells.push(
            <View key={d} style={sharedStyles.hours_cell}>
                <Text style={sharedStyles.footer_text}>{val}</Text>
            </View>
        );
    }

    const userRows = users.map((user, i) => (
        <PdfUser key={i} user={user} lastDay={lastDay} />
    ));

    return (
        <Document style={{ fontFamily: 'BrittiSans' }}>
            <Page orientation="landscape" size="A4" style={sharedStyles.page}>

                {/* ── Header ─────────────────────────────────────────────── */}
                <View style={sharedStyles.header}>
                    <View style={sharedStyles.headerLeft}>
                        <Text style={sharedStyles.h1}>Timesheet details</Text>
                        <View style={sharedStyles.metaRow}>
                            <Text style={sharedStyles.metaLabel}>Customer</Text>
                            <Text style={sharedStyles.metaValue}>{project.client.name}</Text>
                        </View>
                        <View style={sharedStyles.metaRow}>
                            <Text style={sharedStyles.metaLabel}>Project</Text>
                            <Text style={sharedStyles.metaValue}>{project.name}</Text>
                        </View>
                        <View style={sharedStyles.metaRow}>
                            <Text style={sharedStyles.metaLabel}>Period</Text>
                            <Text style={sharedStyles.metaValue}>{periodName}</Text>
                        </View>
                    </View>
                    <View style={sharedStyles.headerRight}>
                        <VariantLogoSymbol size={28} color="#111111" />
                    </View>
                </View>

                {/* ── Table ──────────────────────────────────────────────── */}

                {/* Column header row */}
                <View style={{ ...sharedStyles.tableRow, ...sharedStyles.heading_row }}>
                    <View style={sharedStyles.name_cell_header}>
                        <Text style={sharedStyles.heading_text}>Name</Text>
                    </View>
                    {dayHeaders}
                    <View style={sharedStyles.sum_cell_header}>
                        <Text style={sharedStyles.heading_text}>Sum</Text>
                    </View>
                </View>

                {/* Consultant rows */}
                {userRows}

                {/* Totals row */}
                <View style={{ ...sharedStyles.tableRow, ...sharedStyles.footer_row }}>
                    <View style={sharedStyles.name_cell}>
                        <Text style={sharedStyles.footer_text}>Sum</Text>
                    </View>
                    {sumCells}
                    <View style={sharedStyles.sum_cell}>
                        <Text style={sharedStyles.footer_text}>{formate(project.sum_hours)}</Text>
                    </View>
                </View>

                {/* Total amount */}
                <View style={sharedStyles.amount_row}>
                    <Text style={sharedStyles.amount_label}>Total amount</Text>
                    <Text style={sharedStyles.amount_value}>{currencyFormate(project.sum_amount)}</Text>
                </View>

                {/* ── Page footer ────────────────────────────────────────── */}
                <View style={sharedStyles.pageFooter} fixed>
                    <Text style={sharedStyles.pageFooterText}>
                        Timesheet details · {project.client.name} · {periodName}
                    </Text>
                    <VariantWordmark width={67} color="#111111" />
                </View>

            </Page>
        </Document>
    );
};

export default PdfInvoice;
